const messages: Record<string, string> = {
	'onboardingStart.headline': 'Hello! Check your information so we can begin.',
	'onboardingStart.name': 'Name',
	'onboardingStart.plateNumber': 'Plate number:',
	'onboardingStart.year': 'Year',
	'onboardingStart.timeout': 'This link will be active until ',
	'onboardingStart.support': 'Need help? Call Solvd!',
	'onboarding.headline': 'Ready to start your digital inspection?',
	'onboarding.paragraph': 'Before starting the process, please consider the following:',
	'onboarding.documents':
		"Have the <b>keys</b> and the <b>vehicle's registration card</b> available.",
	'onboarding.camera': 'Photos can only be taken using your <b>smartphone camera</b>.',
	'onboarding.internet':
		'Be in a place with <b>good lighting</b> and a <b>strong internet connection</b>.',
	'onboarding.vehicle':
		'Ensure the vehicle is <b>clean</b>, <b>accessible from all angles</b>, and that all <b>windows are closed</b>.',
	poweredBy: 'Powered by <ce>ControlExpert</ce> a <solvd>Solvd</solvd> group company',
	'onboarding.terms.before': 'Before beginning, please confirm the following:',
	'onboarding.terms.url': 'I agree with <tclink>Terms and conditions</tclink>.',
	'approval.description':
		'Check if the bank account number given below is correct. If so, confirm the estimate and the above amount will be transferred to your account.',
	'approval.lacquerCosts': 'Paintwork',
	'button.changeImage': 'Change the photo',
	'button.anotherImage': 'Take another photo',
	'button.deleteImage': 'Delete the photo',
	'button.acceptImage': 'Accept the photo',
	'button.acceptMileage': 'Correct',
	'validationContainer.correct': 'Correct',
	'button.prev': 'Back',
	'button.next': 'Continue',
	'button.photo.take': 'Take photo',
	'damageImages.title': 'Damage Photos',
	'completeVehicleInformationModal.isRegistrationDocumentUploaded':
		'Photo of the vehicle registration certificate',
	'damageImages.additionalImages': 'Additional photos of the damages',
	'damageImages.description': 'You can add up to {imageCount, number} photos',
	'damageImages.booleanRadioGroupLabel': 'Does your vehicle have any damage?',
	'damageImages.booleanRadioGroupLabelLeft': 'No',
	'damageImages.booleanRadioGroupLabelRight': 'Yes',
	'damageImages.optionalDamageImages': 'Optionally, add more photos showing the damages.',
	'feedback.button.send': 'Send the opinion',
	'feedback.description': 'We hope that you are satisfied with our service.',
	'feedback.rating': 'How do you rate the claim settlement with EasyClaim?',
	'vehicleImages.details.first': 'The front of the vehicle',
	'vehicleImages.details.rearright':
		'Take a photo of the vehicle with the whole rear and right side. The license plate should be readable.',
	'vehicleImages.overviewPhotos': 'Vehicle overview photos',
	'vehicleImagesExampleModal.headline.first': 'Vehicle overview photos – an example',
	'waitForAudit.description.damageFound':
		'The next step is up to us. We will inform you about the result of the inspection by phone or e-mail.',
	'waitForAudit.description.damageNotFound':
		'The next step is up to us. We will inform you about the result of the inspection by phone or e-mail.',
	'vehicleFrontLeftPerspectiveImage.title': 'Photo of the vehicle front left',
	'vehicleFrontLeftPerspectiveImage.description':
		'Take photo of the front left diagonal, ensuring the entire car is in the frame and the license plate is visible.',
	'vehicleFrontRightPerspectiveImage.title': 'Photo of the vehicle front right',
	'vehicleFrontRightPerspectiveImage.description':
		'Take photo of the front right diagonal, ensuring the entire car is in the frame and the license plate is visible.',
	'vehicleRearLeftPerspectiveImage.title': 'Photo of the vehicle rear left',
	'vehicleRearLeftPerspectiveImage.description':
		'Take photo of the rear left diagonal, ensuring the entire car is in the frame and the license plate is visible.',
	'vehicleRearRightPerspectiveImage.title': 'Photo of the vehicle rear right',
	'vehicleRearRightPerspectiveImage.description':
		'Take photo of the rear right diagonal, ensuring the entire car is in the frame and the license plate is visible.',
	'dashboardMileage.title': 'Photo of the odometer',
	'vehicleMileage.description':
		'Capture a photo of the odometer, ensuring that the digital reading is in sharp focus and completely legible.',
	'windshieldImage.description':
		'Capture an photo of the windshield, ensuring the entire glass area and its details are clearly visible.',
	'vinPicture.description':
		'Take a close-up photo of the Vehicle Identification Number (VIN) area, ensuring all characters are legible.',
	'overallDashboardImage.description':
		'Capture an overall photo of the dashboard, making sure all controls and features are fully in view.',
	'review.title': 'Summary of your digital inspection',
	'review.paragraph.first':
		'Before finishing, please verify that all information is correct.<br/><br/>After clicking "Complete", we will confirm your photos and information.',
	'review.button.next': 'Complete',
	'thanks.headline.first': 'Photos received successfully!',
	'thanks.paragraph.first': 'Your request is being reviewed by our technical team.',
	'timeout.headline.first': 'The requested case was not found.',
	'timeout.paragraph.first': 'Your case has expired or the link you accessed is incorrect.',
	'review.stepDescription.group.perspectiveImages': 'Vehicle overview photos',
	'review.stepDescription.vehicleFrontLeftPerspective': 'Photo of the vehicle front left',
	'review.stepDescription.vehicleFrontRightPerspective': 'Photo of the vehicle front right',
	'review.stepDescription.vehicleRearLeftPerspective': 'Photo of the vehicle rear left',
	'review.stepDescription.vehicleRearRightPerspective': 'Photo of the vehicle rear right',
	'review.stepDescription.group.additionalImages': 'Additional pictures',
	'review.stepDescription.questions': 'Vehicle information',
	'missingPhoto.title': 'Missing photo',
	'missingPhoto.description':
		'It seems that a photo is missing. Please add the missing photo to proceed.',
	'blockedByDevice.headline': 'Use a smartphone',
	'blockedByDevice.paragraph.first':
		'This link can only be used on smartphones. Scan the following QR code with your smartphone to begin the process.',
	'blockedByDevice.paragraph.second':
		'A quick tip: when opening the link, you should be near the vehicle and have your documents ready.',
	'photoUploading.title': 'Uploading',
	'photoAnalyzing.title': 'Analyzing',
	'photoLoading.title': 'Loading',
	'landscapeModeDetected.title': 'Auto-rotate enabled',
	'landscapeModeDetected.text':
		'Please disable auto-rotate on your device for a better camera experience.',
	'button.hint': "Where's my VIN number located?",
	'hint.vin': 'XXXXXXXXXXXXXXXXX',
	'hint.vin.title': 'Possible VIN locations',
	'hint.vin.description': 'It can typically be found in those 4 locations:',
	'hint.vin.location1': "On the dashboard, visible through the windshield on the driver's side.",
	'hint.vin.location2': "On the driver's side door frame, near the latch.",
	'hint.vin.location3': 'In the engine bay, often on a metal plate.',
	'hint.vin.location4': 'Front end of frame (older vehicles).',
	'thankYou.message': 'Your request is being reviewed by our technical team.',
	'feedback.title': 'We would appreciate your feedback.',
	'feedback.message':
		'On a scale of 0 to 5, how would you rate your experience having your digital inspection done with us?',
	'feedback.helpImprove': 'Help us improve (optional):',
	'feedback.error.maxLength': 'Feedback cannot exceed more than {maxLength} characters.',
	'invalidFile.size.title': 'Incorrect photo size',
	'invalidFile.size.description': 'The photo size is bigger than the maximum required',
	'invalidFile.extension.title': 'File type is not supported',
	'invalidFile.extension.description':
		'The specified file type is not supported. Supported file types: .jpg, .jpeg, .jfif, .heic, .heif, .png and .bmp',
	'dashboardMileage.placeholder.updated': 'insert mileage (km)',
	'questions.DoesTheVehicleHaveCNG': 'Doses the vehicle have CNG?',
	'questions.ArmoredVehicle': 'Armored vehicle?',
	'questions.DoesTheVehicleHaveModifiedSuspension': 'Does the vehicle have modified suspension?',
	'questions.WasTheChassisNumberRemarked': 'Was the chassis number remarked?',
	'questions.yes': 'Yes',
	'questions.no': 'No',
	'questions.paragraph':
		'If the vehicle has any modifications that you wish to document, please answer the following questions:',
	'questions.title': 'Vehicle information',
	'fullscreen.prompt': 'Fullscreen mode is available for a better experience',
	'fullscreen.prompt.accept': 'Open in fullscreen',
	'fullscreen.prompt.dismiss': 'Continue',
	'camera.darkWarning':
		'The environment is potentially too dark — please improve the lighting for better photo quality.',
	'button.continue': 'Continue',
	'button.start': 'Start',
	'windshieldImage.title': 'Windshield image',
	'vinPicture.title': 'Photo of the VIN number',
	'overallDashboardImage.title': 'Overall dashboard image',
	'dashboardMileage.paragraph.first': 'Enter the vehicle mileage.',
	'review.stepDescription.damageImages': 'Damage Images',
	'review.stepDescription.fourAdditionalDocuments': 'Vehicle details',
	'review.stepDescription.registrationDocument':
		'Photo of the registration certificate (the front)',
	'review.stepDescription.registrationDocumentInside':
		'Photo of the registration certificate (the reverse)',
	'fourAdditionalDocuments.title': 'Vehicle details',
	'fourAdditionalDocuments.RegistrationDocument.title':
		'Photo of the registration certificate (the front)',
	'fourAdditionalDocuments.RegistrationDocument.description':
		'Take a photo of the registration certificate (the front)',
	'fourAdditionalDocuments.RegistrationDocumentInside.title':
		'Photo of the registration certificate (the reverse)',
	'fourAdditionalDocuments.RegistrationDocumentInside.description':
		'Take a photo of the registration certificate (the reverse)',
	'vehicleRegistrationDocument.title': 'Vehicle details',
	'vehicleRegistrationDocument.RegistrationDocument.title':
		'Photo of the registration certificate (the front)',
	'vehicleRegistrationDocument.RegistrationDocument.description':
		'Take a photo of the registration certificate (the front)',
	'vehicleRegistrationDocument.RegistrationDocumentInside.title':
		'Photo of the registration certificate (the reverse)',
	'vehicleRegistrationDocument.RegistrationDocumentInside.description':
		'Take a photo of the registration certificate (the reverse)',
	'connectionError.title': 'Connection error',
	'connectionError.description': 'Connection error. Please upload picture again.',
	'additionalDamagePictures.title': 'Damage Photos',
	'damagedImages.booleanRadioGroupLabel': 'Does your vehicle have any damage?',
	'damagedImages.description': 'You can add up to {imageCount, number} photos',
	'damagedImages.booleanRadioGroupLabelLeft': 'No',
	'damagedImages.booleanRadioGroupLabelRight': 'Yes',
	'damageImages.photo': 'Damage photo',
	'review.stepDescription.windshield': 'Windshield image',
	'review.stepDescription.vinPicture': 'Photo of the VIN number',
	'review.stepDescription.overallDashboard': 'Overall dashboard image',
	'review.stepDescription.mileage': 'Photo of the odometer',
	'landing.headline': 'Welcome to<br />SmartClaim Damage Assessment',
	'landing.paragraph': 'We make a damage estimate in<br />3 simple steps:',
	'landing.stepDescription.fourDiagonalPerspectives': 'Upload photos of your vehicle',
	'landing.stepDescription.damageImages': 'Upload photos of the damage',
	'landing.stepDescription.damageDescription': 'Briefly tell us what happened',
	'landing.additional-informations-section.text':
		'Based on the data provided, our experts will analyze the claim reported and the damage to the vehicle.<br />By going ahead I declare that I will only present the damage relating to this claim.',
	'landing.termsAndConditionsLink':
		'To proceed, you should read and familiarize yourself with the Allianz Portugal Privacy Policy.',
	'fourDiagonalPerspectives.vehicleFrontLeft.title':
		'Take a photo of the front left diagonal of the entire vehicle. The license plate must be legible.',
	'fourDiagonalPerspectives.vehicleRearRight.title':
		'Take a photo of the rear right diagonal of the entire vehicle. The license plate must be legible.',
	'fourDiagonalPerspectives.vehicleFrontLeft.exampleModalTitle':
		'FRONT LEFT DIAGONAL EXAMPLE PHOTO',
	'fourDiagonalPerspectives.vehicleRearRight.exampleModalTitle':
		'REAR RIGHT DIAGONAL EXAMPLE PHOTO',
	'damageImages.headline': 'Pictures of the damage',
	'completeDamageImages.description':
		'Take at least 2 pictures of the incident from different perspectives (close-up/full frame).',
	'imageRecognitionFeedback2.exemplaryPhoto': 'Photo example',
	'imageRecognitionMismatchModal.headline': "Let's check if the photos you added are correct",
	'button.backchangeImage': 'Retake the photo',
	'completeVehicleImagesModal.headline': 'Missing photos',
	'completeVehicleImagesModal.hasVehicleImageFrontLeft': 'Front left diagonal',
	'completeVehicleImagesModal.hasVehicleImageRearRight': 'Rear right diagonal',
	'vehicleImages.leftFrontOverview': 'Front left diagonal',
	'vehicleImages.rightRearOverview': 'Rear right diagonal',
	'fourPerspectivesExampleModal.button.close': 'Close',
	'damageDescription.headline.first': 'Damage description',
	'damageDescription.paragraph.first': 'Briefly describe the damage',
	'damageDescription.placeholder':
		'For example: Another car hit me in the side at an intersection. My left front fender was damaged.',
	'review.headline.first': 'Verification',
	'review.stepDescription.fourDiagonalPerspectives': 'Photos of the vehicle',
	'review.stepDescription.damageDescription': 'Damage description',
	'review.editViewButton': 'View/Edit',
	'thankYou.headline': 'Thank you for using SmartClaim Damage Assessment Service!',
	'thankYou.paragraph.first': 'We confirm that the information has been sent correctly.',
	'thankYou.paragraph.second':
		'We will estimate the cost of the repair based on the photographs sent of the damage in 4 hours.',
	'thankYou.paragraph.third': '(within working schedule Monday to Friday from 9am to 6pm)',
	'thankYou.paragraph.fourth':
		'We will send you the estimate of the repair to your email that you have informed us.',
	'thankYou.button.next': 'Review',
	'feedback.yourOpinion': 'Please give us your feedback (optional)',
	'feedback.notSatisfied': 'not satisfied',
	'feedback.verySatisfied': 'very satisfied',
	'landingApproval.headline': 'Welcome to<br />SmartClaims Damage Assessment',
	'landingApproval.paragraph.first': 'We have an offer for you!',
	'landingApproval.paragraph.second':
		"We've analyzed the information you've sent us and we have an offer for you.<br /><br />The amount proposed is the cost of the repair at a workshop in our network for a period of 3 months.",
	'landingApproval.button.next': 'Next',
	'cashSettlementOffer.headline': 'Cash Settlement Offer',
	'cashSettlementOffer.description':
		"Based on damage assesment done by our experts, we would like to offer the following cash offer for your vehicle's repair ammount:",
	'cashSettlementOffer.paragraph.first':
		'Please note: your claim is still under analysis, so this offer may change.',
	'cashSettlementOffer.paragraph.second':
		'If the invoice for the repair plus VAT exceeds our quote, we will refund the VAT. To do so, you must send us the invoice to info@allianz.pt, including the claim number in the subject line, within 2 months of accepting this offer.',
	'cashSettlementOffer.paragraph.third':
		'After accepting the offer, payment will be sent to your bank account within 3 working days.',
	'cashSettlementOffer.table.title': 'Summary',
	'cashSettlementOffer.table.repairCost': 'Repair cost',
	'cashSettlementOffer.table.deductible': 'Deductible',
	'cashSettlementOffer.table.sum': 'Cash offer',
	'cashSettlementOffer.table.vat': '(without VAT)',
	'cashSettlementOffer.accept': 'Payment Details',
	'cashSettlementOffer.reject': 'Reject Offer',
	'bankDetails.headline': 'Bank transfer details',
	'bankDetails.paragraph.first':
		'Please provide us your bank transfer details based on your preferred payment method.<br />Make sure the information provided is correct before proceeding.',
	'bankDetails.accountHolder.label': 'Account holder',
	'bankDetails.accountHolder.placeholder': 'John Doe',
	'bankDetails.accountHolder.error': '*Name not provided',
	'bankDetails.tin.label': 'NIF',
	'bankDetails.tin.placeholder': '123456789',
	'bankDetails.tin.error': '*NIF not recognized',
	'bankDetails.iban.label': 'IBAN',
	'bankDetails.iban.emptyIban': 'Please provide bank account number.',
	'bankDetails.iban.ibanChanged': 'New IBAN inserted. Please attach proof of IBAN.',
	'bankDetails.iban.invalidIban':
		'The client indicates a different IBAN from the one registered in the policy and the IBAN is invalid.',
	'bankDetails.iban.notPortugueseError':
		'Invalid IBAN format. Please check that the IBAN entered is correct and attach proof of this.',
	'bankDetails.iban.placeholder': 'PT50 0010 0000 5555 7777 8888 1',
	'bankDetails.file.label': 'Bank account statement - IBAN/NIF',
	'bankDetails.file.label.extensions': '(pdf or jpge files)',
	'bankDetails.file.placeholder': 'BankAccount.pdf',
	'bankDetails.accept': 'Confirm and Accept',
	'bankDetails.reject': 'Reject Offer',
	'bankDetails.modal.headline': 'Hint',
	'bankDetails.modal.description': 'Please make sure:',
	'bankDetails.modal.notUploaded': 'You have attached proof of IBAN.',
	'bankDetails.modal.invalidIban': 'Your IBAN is valid.',
	'bankDetails.modal.notPortugueseError':
		'The IBAN has been correctly indicated (we only accept Portuguese IBANs).',
	'bankDetails.modal.wrongFile': 'Incorrect file. Please try again or attach another file.',
	'waitForAudit.thankYou': 'Thank you for your feedback!',
	'nooffer.paragraph.first': "Sorry, we couldn't make you an offer!",
	'nooffer.paragraph.second':
		'Allianz will contact you as soon as possible to support you processing your claim through a non-digital channel.',
	'button.finish': 'Finish',
	'offerAccepted.headline': "We've received your response.",
	'offerAccepted.rating': 'How would you rate our offer?',
	'offerRejected.headline': "We're sorry you didn't accept our offer!",
	'offerRejected.description':
		'Allianz will contact you as soon as possible to support you processing your claim through a non-digital channel.',
	'offerRejected.rating': 'How would you rate our offer?',
	'impactDirections.title':
		'Our proposal refers to the damage shown in the diagram below, resulting from the claim',
	'impactDirections.button.next': 'Check Offer',
};

export default messages;
